module.exports = __webpack_public_path__ + "img/hai_1.96258e03.gif";